/* eslint-disable react/prop-types */
import React from "react";
import Button from "react-bootstrap/Button";
import { MdOutlineArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const ReturnButton = (props) => {
  const navigate = useNavigate();

  if (props.direction) {
    return (
      <Button
        variant='info'
        onClick={() => navigate(`${props.direction}`)}
        className='mt-3 mb-2'
        type='link'
      >
        <MdOutlineArrowBack /> Return
      </Button>
    );
  } else {
    return (
      <Button variant='info' onClick={() => navigate(-1)} className='mt-3 mb-2' type='link'>
        <MdOutlineArrowBack /> Return
      </Button>
    );
  }
};

export default ReturnButton;
